import { CRS_CONSTANTS } from '../../pages/constants/crsContants';
import { CustomerProfileModule } from './apiModules/RiskDetailModules/customerProfileModule';
import { AssociatedCustomersModule } from './apiModules/RiskDetailModules/associatedCustomersModule';
import { AlertHistoryModule } from './apiModules/RiskDetailModules/alertHistoryModule';
import { TrendAnalysisModule } from './apiModules/RiskDetailModules/trendAnalysisModule';
import { TransactionHistoryModule } from './apiModules/RiskDetailModules/transactionHistoryModule';
import { ClusterInformationModule } from './apiModules/RiskDetailModules/clusterInformationModule';
import { FeatureCodesModule } from './apiModules/RiskDetailModules/featureCodesModule';
import { ModelExplainAbilityModule } from './apiModules/RiskDetailModules/modelExplainabilityModule';
import { RiskIndicatorsModule } from './apiModules/RiskDetailModules/riskIndicatorsModule';
import { RiskScoreHistoryModule } from './apiModules/RiskDetailModules/riskScoreHistoryModule';
import { RiskScoreAcceptanceModule } from './apiModules/RiskDetailModules/riskScoreAcceptanceModule';

const PREDICTION = 'PREDICTION';
const GROUP = 'GROUP';
const RED_FLAG = 'RED_FLAG';
const FEATURE = 'FEATURE';

const { AMLS_COMMON, CRS_BASE_URL, HTTP_HEADERS } = CRS_CONSTANTS;

export class NetworkLayer {
  constructor() {
    const { CRS_BASE_URL, HTTP_HEADERS } = CRS_CONSTANTS;
    this.baseUrl = CRS_BASE_URL;
    this.httpHeaders = HTTP_HEADERS;
    this.alertHistoryModuleObject = new AlertHistoryModule(
      AMLS_COMMON,
      HTTP_HEADERS
    );
    this.customerProfileModule = new CustomerProfileModule(
      CRS_BASE_URL,
      HTTP_HEADERS
    );
    this.associatedCustomersModule = new AssociatedCustomersModule(
      CRS_BASE_URL,
      HTTP_HEADERS
    );
    this.trendAnalysisModule = new TrendAnalysisModule(
      CRS_BASE_URL,
      HTTP_HEADERS
    );
    this.transactionHistoryModule = new TransactionHistoryModule(
      CRS_BASE_URL,
      HTTP_HEADERS
    );
    this.clusterInformationModule = new ClusterInformationModule(
      CRS_BASE_URL,
      HTTP_HEADERS
    );
    this.featureCodeModule = new FeatureCodesModule(CRS_BASE_URL, HTTP_HEADERS);
    this.modelExplainAbilityModule = new ModelExplainAbilityModule(
      CRS_BASE_URL,
      HTTP_HEADERS
    );
    this.riskIndicatorsModule = new RiskIndicatorsModule(
      CRS_BASE_URL,
      HTTP_HEADERS
    );
    this.riskScoreHistoryModule = new RiskScoreHistoryModule(
      CRS_BASE_URL,
      HTTP_HEADERS
    );
    this.riskScoreAcceptanceModule = new RiskScoreAcceptanceModule(
      CRS_BASE_URL,
      HTTP_HEADERS
    );
  }

  customerProfileAPI = async (payload) =>
    await this.customerProfileModule.fetchCustomerProfile(payload);
  associatedCustomersAPI = async (payload) =>
    await this.associatedCustomersModule.fetchAssociatedCustomers(payload);
  alertHistoryAPI = async (payload) =>
    await this.alertHistoryModuleObject.fetchAlertHistory(payload);
  amlsCommonUnifiedAlertCountsByMetricsNameAPI = async (payload) =>
    await this.alertHistoryModuleObject.fetchAMLSCommonUnifiedAlertCountsByMetricsNameAPI(
      payload
    );
  trendAnalysisAPI = async (payload) =>
    await this.trendAnalysisModule.fetchTrendAnalysis(payload);
  transactionHistoryAPI = async (payload) =>
    await this.transactionHistoryModule.fetchTransactionHistory(payload);
  transactionProductMappingAPI = async (payload) =>
    await this.transactionHistoryModule.fetchTransactionProductMapping(payload);
  transactionTypesAPI = async (payload) =>
    await this.transactionHistoryModule.fetchTransactionTypes(payload);
  clusterInformationAPI = async (payload) =>
    await this.clusterInformationModule.fetchClusterInformation(payload);
  clusterViewDescriptionCodesAPI = async (payload) =>
    await this.clusterInformationModule.fetchClusterViewDescriptionCodes(
      payload
    );
  featureCodesAPI = async (payload) =>
    await this.featureCodeModule.featureCodes(payload);
  featureCategoryCodesAPI = async (payload) =>
    await this.featureCodeModule.featureCategoryCodes(payload);
  modelExplainAbilityAPI = async (payload) =>
    await this.modelExplainAbilityModule.fetchModelExplainAbility(payload);
  modelExplainAbilityStatsAPI = async (payload) =>
    await this.modelExplainAbilityModule.fetchModelExplainAbilityStats(payload);
  riskIndicatorGraphAPI = async (payload) =>
    await this.riskIndicatorsModule.fetchRiskIndicatorGraph(payload);
  riskIndicatorsListAPI = async () =>
    await this.riskIndicatorsModule.fetchListOfRiskIndicators();
  updateRiskScoreHistoryAPI = async (payload) =>
    await this.riskScoreHistoryModule.updateRiskScoreHistory(payload);
  getRiskScoreHistoryAPI = async (payload) =>
    await this.riskScoreHistoryModule.getRiskScoreHistory(payload);
  acceptRiskScoreAPI = async (payload) =>
    await this.riskScoreAcceptanceModule.acceptRiskScore(payload);
}
